<template>
  <div class="page-login" v-loading="loading">
    <div class="content-wrap">
      <div class="left-logo-wrapper">
        <!-- <img src="../assets/logo-company.png" alt=""> -->
        <div class="name">数字人管理系统</div>
      </div>
      <div class="right-form-wrapper">
        <div class="login-text">{{ isLogin ? '登录' : '注册' }}</div>
        <div class="form-text">手机号</div>
        <el-input maxlength="11" v-model="form.userPhone" placeholder="请输入手机号" @input="handlePhoneInput"></el-input>
        <div class="form-text-pwd">密码</div>
        <el-input minlength="6" v-model="form.password" placeholder="请输入密码，长度不小于6位" show-password></el-input>
        <div v-if="!isLogin">
          <div class="form-text-pwd">确认密码</div>
          <el-input v-model="form.confirmPassword" placeholder="请输入确认密码" show-password></el-input>
        </div>
        <div class="login-btn" @click="doLogin">{{ isLogin ? '登录' : '确认并登录' }}</div>
        <div class="no-account" v-if="isLogin">没有账号？<span @click="toRegister">立即注册</span></div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router'
import { login, register } from '@/api/index'
import { ElMessage } from 'element-plus'
export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const state = reactive({
      isLogin: true,
      form: {
        userPhone: '',
        password: '',
        confirmPassword: ''
      },
      loading: false
    })
    const handlePhoneInput = (value) => {
      state.form.userPhone = value.replace(/\D/g, '');
    }
    const toRegister = () => {
      state.isLogin = false
      state.form.userPhone = ''
      state.form.password = ''
    }
    const checkPassword = () => {
      if (state.form.password !== state.form.confirmPassword) {
        ElMessage.error('两次密码不一致')
        return false
      } else {
        return true
      }
    }
    const checkPasswordLength = () => {
      if (state.form.password.length < 6) {
        ElMessage.error('密码长度不能小于6位')
        return false
      } else {
        return true
      }
    }
    const loginMethod = async() => {
      const data = {
              phone_number: state.form.userPhone,
              password: state.form.password
            }
            state.loading = true
            const res = await login(data)
            console.log("res", res)
            if (res.code == 200) {
              state.loading = false
              const userId = res.data.id
              localStorage.setItem('userId', userId)
              // localStorage.setItem('userPhone',res.data.phone_number)
              goHomePage()
            } else {
              state.loading = false
              ElMessage.error('登录失败！')
            }
    }
    const doLogin = async () => {
      try {
        if (state.isLogin) {
          if (checkPasswordLength()) {
            // 登录
            loginMethod()
          }
        } else {
          // 注册
          if (checkPasswordLength() && checkPassword()) {
            const data = {
              phone_number: state.form.userPhone,
              password: state.form.password,
              password2: state.form.confirmPassword
            }
            state.loading = true
            const res = await register(data)
            console.log("register", res)
            if (res.code == 200) {
              state.loading = false
              loginMethod()
            } else {
              state.loading = false
              ElMessage.error('注册失败！')
            }
          }
        }
      } catch (error) {
        console.log(error)
        localStorage.removeItem('userId')
        state.loading = false
      }
    }
    const goHomePage = () => {
      router.push('/home')
    }
    return {
      ...toRefs(state),
      toRegister,
      doLogin,
      handlePhoneInput
    }
  }
}

</script>
<style lang="less" scoped>
.page-login {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .content-wrap {
    width: 100vw;
    height: 60vh;
    margin-top: 15vh;
    margin-left: calc(50vw - 350px);

    .left-logo-wrapper {
      display: inline-block;
      width: 300px;
      vertical-align: top;

      img {
        width: 200px;
        display: inline-block;
        margin-top: 60px;
      }

      .name {
        font-size: 24px;
        font-weight: 600;
        margin-top: 130px;
      }
    }

    .right-form-wrapper {
      width: 300px;
      display: inline-block;
      border: 1px solid #ccc;
      border-radius: 10px;
      padding: 20px;

      .login-text {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .form-text {
        font-size: 16px;
        margin-bottom: 10px;
        color: #333;
      }

      .form-text-pwd {
        color: #333;
        font-size: 16px;
        margin-bottom: 10px;
        margin-top: 15px;
      }

      .login-btn {
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;
        margin-top: 20px;
      }

      .no-account {
        font-size: 16px;
        color: #969696;
        margin-top: 20px;
        text-align: center;

        span {
          border-bottom: 1px solid #969696;
          cursor: pointer;
        }
      }

      /deep/.el-input__inner {
        height: 40px;
      }
    }
  }


}
</style>